import { AddressType } from '../../AddressType';
import { addressFormatter } from './addressFormatter';

export function longAddress(
  address: Partial<AddressType> | null | undefined
) {
  return addressFormatter(address, [
    'street1',
    'street2',
    'city',
    'state',
    'country',
    'code',
  ]);
}
